import React from 'react';
import PollEntity from './../../../store/polls-store/poll-entity';
import { sortByPrioritize } from '../../../utils/helpers/prioritize-helpers';
import DraggablePollWrapper from '../draggable-polls-list/draggable-polls-wrapper';
import { observer } from 'mobx-react';

interface IProps {
    list: PollEntity[];
    selectPoll: (pollId: string) => void;
    isOnePollOpened: boolean;
}

const PollsList: React.FC<IProps> = ({
  list,
  selectPoll,
  isOnePollOpened
}) => {
  const sortedPollsList = sortByPrioritize(list) as PollEntity[];
  const pollsListCN = `polls-list ${isOnePollOpened && 'polls-list-opened-handler'}`;

  return (
    <ul className={pollsListCN}>
      {sortedPollsList.map((poll: PollEntity, index: number) => {
        return (
          <DraggablePollWrapper
            key={poll.getId()}
            poll={poll}
            index={index}
            selectPoll={selectPoll}
          />
        );
      }
      )}
    </ul>
  );
};

export default observer(PollsList);
